import { useAtomValue } from 'jotai';
import { bulkProvisioningFiltersAtom } from 'atoms/filters/bulk-provisioning.ts';
import { useHasActiveProvisioningFilters } from './useHasActiveProvisioningFilters.ts';

export const useIsProvisioningFiltered = () => {
  const filters = useAtomValue(bulkProvisioningFiltersAtom);

  return useHasActiveProvisioningFilters(filters);
};
